module.exports = __webpack_public_path__ + "static/media/mail.70b26e82.webp";